import React, { useEffect, useRef, useState } from 'react';
import "./RenderPopover.scss";
import Popover from '@mui/material/Popover';
import Button from 'react-bootstrap/esm/Button';
import Toast from "components/Toast";
import { getAllPaymentModes, saveAdvancePayment } from 'core/services/api';
import Select from "react-select";
import PaytmPOS from './PaytmPOS';

function RenderPopover({ id, handleClose, anchorEl, open, invoice, centerId }: any) {

  const initialData = {
    trustName: "",
    advancePayment: 0,
    advancePaymentMode: "CASH",
    securityDeposit: 0,
    securityDepositMode: "CASH",
    sdBankName: "",
    sdCompanyName: "",
    sdChequeNo: "",
    sdCardNo: "",
    sdTransactionId: ""
  }

  const [data, setData] = useState<any>(initialData);
  const [displayToast, toggleDisplayToast] = useState<any>();
  const [paymentDropdown, setPaymentDropdown] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const saveRef = useRef<any>(null);


  const saveAdvance = () => {
    const jsonData = {
      trustName: data.trustName,
      securityDeposit: data.securityDeposit,
      securityDepositTransactionDetails: {
        transactionId: data.sdTransactionId,
        modeOfPayment: data.securityDepositMode,
        bankName: data.sdBankName,
        companyName: data.sdCompanyName,
        cardNumber: data.sdCardNo,
        chequeNo: data.sdChequeNo,
        tpaName: "",
      },
    }
    saveAdvancePayment(jsonData, invoice?.id).then((res: any) => {
      setIsLoading(false)
      toggleDisplayToast({ text: "Payment Details has been saved successfully", type: "success" })

    }).catch((err: any) => {
      setIsLoading(false)
      toggleDisplayToast({ text: "Unable to add Payment details", type: "error" })
    })

    saveRef.current.blur()

  }

  const [isPopoverExpanded, setIsPopoverExpanded] = useState(false);
  const togglePopoverExpansion = (isOpen: any) => {
    setIsPopoverExpanded(isOpen);
  };

  useEffect(() => {
    getAllPaymentModes()
      .then((res: any) => {
        const temp = res?.paymentMode?.map((values: any) => {
          return {
            label: values,
            value: values,
          }
        })
        setPaymentDropdown(temp);
      })
      .catch((err) => {
        console.error("err", err)
      })
  }, [])

  return (
    <>
      {isLoading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: "50%",
          }}
        >
          <div
            style={{ width: "3rem", height: "3rem" }}
            className="spinner-border text-primary"
          ></div>
        </div>
      )}
      {
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          sx={{ width: "100%" }}
        >
          <div
            className='popper-wrapper'
            style={{
              height: isPopoverExpanded ? '450px' : 'auto', // Adjust the 
            }}

          >
            <div className='blue-common-heading'>Add Security Deposit</div>
            <div className='wrapper-inputs'>
              <div className="title-name">Funds/Trust Name </div>
              <input
                type="text"
                className="form-control-width"
                name="securityDeposit"
                value={data.trustName}
                onChange={(e) => {
                  setData({ ...data, trustName: e.target.value })
                }}
              />
            </div>
            <div className='wrapper-inputs'>
              <div className="title-name">Amount</div>
              <input
                type="text"
                className="form-control-width"
                name="securityDeposit"
                value={data.securityDeposit}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  const numericRegex = /^[0-9]*\.?[0-9]*$/;
                  if (numericRegex.test(inputValue)) {
                    setData({ ...data, securityDeposit: inputValue });
                  } else {
                    setData({ ...data, securityDeposit: '' });
                  }

                }}
              />
            </div>
            <div className='wrapper-inputs'>
              <div className="title-name">Payment Mode</div>
              <div className='payment-mode-wrapper'>
                <Select
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ccd0e7",
                      borderRadius: "10px"
                    })
                  }}
                  className="select-payment"
                  name="modeOfPayment"
                  defaultValue={{
                    label: data.securityDepositMode,
                    value: data.securityDepositMode
                  }}
                  options={paymentDropdown}
                  onMenuOpen={() => togglePopoverExpansion(true)} // Dropdown opened
                  onMenuClose={() => togglePopoverExpansion(false)} // Dropdown closed
                  onChange={(evnt) => {
                    setData({ ...data, securityDepositMode: evnt?.value })
                  }}
                />
              </div>
            </div>
            {["CARD"].includes(data.securityDepositMode) ?
              <>

                <div className='wrapper-inputs'>
                  <div className="title-name">Card Number</div>
                  <input
                    type="text"
                    className="form-control-width"
                    name="securityDeposit"
                    value={data.sdCardNo}
                    onChange={(e) => {
                      setData({ ...data, sdCardNo: e.target.value })
                    }}
                  />
                </div></> : <></>
            }
            {["PAYTM/GPAY/UPI/PHONEPAY"].includes(data.securityDepositMode) ?
              <>

                <div className='wrapper-inputs'>
                  <div className="title-name">Transaction Id</div>
                  <input
                    type="text"
                    className="form-control-width"
                    name="securityDeposit"
                    value={data.sdTransactionId}
                    onChange={(e) => {
                      setData({ ...data, sdTransactionId: e.target.value })
                    }}
                  />
                </div></> : <></>
            }
            {["CHEQUE", "RTGS", "NEFT"].includes(data.securityDepositMode) ?
              <>

                <div className='wrapper-inputs'>
                  <div className="title-name">Bank Name</div>
                  <input
                    type="text"
                    className="form-control-width"
                    name="securityDeposit"
                    value={data.sdBankName}
                    onChange={(e) => {
                      setData({ ...data, sdBankName: e.target.value })
                    }}
                  />
                </div>
                <div className='wrapper-inputs'>
                  <div className="title-name">Cheque Number</div>
                  <input
                    type="text"
                    className="form-control-width"
                    name="securityDeposit"
                    value={data.sdChequeNo}
                    onChange={(e) => {
                      setData({ ...data, sdChequeNo: e.target.value })
                    }}
                  />
                </div>
              </> : <></>}
            {["CGHS", "GOVERNMENT SCHEMES", "CORPORATE", "PSU"].includes(data.securityDepositMode) ?
              <>

                <div className='wrapper-inputs'>
                  <div className="title-name">Transaction Id</div>
                  <input
                    type="text"
                    className="form-control-width"
                    name="securityDeposit"
                    value={data.sdTransactionId}
                    onChange={(e) => {
                      setData({ ...data, sdTransactionId: e.target.value })
                    }}
                  />
                </div>

                <div className='wrapper-inputs'>
                  <div className="title-name">Company Name</div>
                  <input
                    type="text"
                    className="form-control-width"
                    name="securityDeposit"
                    value={data.sdCompanyName}
                    onChange={(e) => {
                      setData({ ...data, sdCompanyName: e.target.value })
                    }}
                  />
                </div>

              </> : <></>}
            {
              ["POS MACHINE"].includes(data.securityDepositMode) ? <>
                <PaytmPOS invoice={invoice} centerId={centerId} transactionAmt={data?.securityDeposit} toggleDisplayToast={toggleDisplayToast} paymentType="SECURITY_DEPOSIT" /></> :
                <>
                  <hr />
                  <div className='buttons-row'>
                    <Button ref={saveRef} className='common-button'
                      onClick={saveAdvance}
                      disabled={isLoading || displayToast}
                    >Save</Button>
                  </div>
                </>

            }

            {displayToast && (
              <Toast
                textMessage={displayToast?.text}
                type={displayToast?.type}
                onClose={() => {
                  toggleDisplayToast(false)
                  if (displayToast?.type === "success") {
                    window.location.reload();
                  }
                }}
                onCloseText="Close"
                onClickText={null}
              />
            )}
          </div>
        </Popover>

      }
    </>
  )
}
export default RenderPopover

